import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import InfoView from 'sharedComponents/InfoView';
import InfoViewSkeleton from 'sharedComponents/InfoViewSkeleton';

import { alphabetizeClients } from 'sharedHelpers/clientHelpers';

import useClientListHydration from 'sharedHooks/useClientListHydration';
import useFilterClients from 'sharedHooks/useFilterClients';

import AddClientButton from '../client/components/AddClientButton';
import ClientListPanelItem from '../client/components/ClientListPanelItem';
import Dashboard from './components/Dashboard';

interface DashboardPageProps {
  clientId?: string;
}

function DashboardPage({ clientId }: DashboardPageProps): JSX.Element {
  const { showClientsDashboardFlag } = useFlags();

  const {
    clients,
    loading,
    isBackgroundLoadingClients,
  } = useClientListHydration();

  const filteredClientsList = useFilterClients({
    clientsList: clients,
    sortFunction: alphabetizeClients,
  });

  return (
    <>
      {loading && <InfoViewSkeleton />}
      {!loading && (
        <InfoView
          selectedItem={clientId}
          listPanelChildren={({ index, style }) => (
            <ClientListPanelItem
              clientsData={filteredClientsList}
              style={style}
              index={index}
            />
          )}
          detailPanelChildren={showClientsDashboardFlag && <Dashboard />}
          title="Dashboard"
          loadingMessage={
            isBackgroundLoadingClients ? 'Loading more clients…' : undefined
          }
          numberOfItems={filteredClientsList.length}
          HeaderButton={<AddClientButton />}
          errorMessage={
            clients.length > filteredClientsList.length
              ? 'There are no clients matching the current filters'
              : 'You have no clients to display'
          }
        />
      )}
    </>
  );
}

DashboardPage.defaultProps = {
  clientId: undefined,
};

export default DashboardPage;
